import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { clearCacheKeepingAuth } from '@/api/auth/auth-query';
import { useRole } from '@/lib/auth/role-context';
import { SIGN_IN } from '@/lib/constants/routes';

/**
 * Chiude la sessione lato client e porta al login, senza chiamare il server:
 * lo usano l'uscita (dopo il sign-out andato a buon fine) e la schermata di
 * `/me` non riuscita, dove il server non risponde.
 *
 * Ordine: si fermano le richieste in corso, si segna la sessione come chiusa,
 * si va al login (la pagina smonta dashboard e sidebar) e SOLO DOPO si svuota
 * la cache. Svuotata con le query ancora montate, ognuna ripartiva da capo e
 * il server rispondeva 401 a tutte. Resta la sola voce di `/me`, non
 * autenticata, che `RoleProvider` osserva e il login successivo riscrive.
 */
export function useLocalSignOut(): () => Promise<void> {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { logout } = useRole();

  return async () => {
    await queryClient.cancelQueries();
    logout();
    await navigate({ to: SIGN_IN });
    clearCacheKeepingAuth(queryClient);
  };
}
